import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  box: {
    maxHeight: '30px',
    minHeight: '30px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  },
  multibox: {
    justifyContent: 'space-between',
    VerticalAlignBottom: 'bottom',
    display: 'flex',
    flexDirection: 'row',
    marginTop: 'auto',
    marginBottom: 'auto',
    alignItems: 'center',
  },
  button: {
    padding: '0.3rem 1rem',
    fontSize: '12px',
  },
  textfield: {
    minWidth: 50,
    maxWidth: 400,
    width: '100%',
    height: 30,
  },
  autocomplete: {
    height: 50,
    minWidth: 50,
    maxWidth: 400,
    width: '100%',
  },
  dropdown: {
    minWidth: 50,
    maxWidth: 400,
    width: '100%',
    textOverflow: 'ellipsis',
    height: 30,
  },
  multicomplete: {
    minWidth: 50,
    maxWidth: 400,
    width: '100%',
    marginTop: 'auto',
    marginBottom: 'auto',
    verticalAlign: 'center',
    alignItems: 'center',
    alignContent: 'center',
  },
  multigrid: {
    marginTop: 'auto',
  },
  unSelected: {
    color: theme.palette.grey[500],
  },
  checkbox: {
    height: 10,
  },
}));

export default useStyles;
